// extracted by mini-css-extract-plugin
export var border = "_b-7";
export var brand = "_b-r";
export var button = "_b-j";
export var center = "_b-9";
export var centered = "_b-5";
export var closeButton = "_b-b";
export var disabledWrapper = "_b-k";
export var error = "_b-n";
export var extraLarge = "_b-4";
export var extraSmall = "_b-1";
export var fill = "_b-g";
export var footer = "_b-f";
export var footerAction = "_b-h";
export var footerButtons = "_b-i";
export var header = "_b-6";
export var icon = "_b-m";
export var info = "_b-q";
export var inline = "_b-8";
export var large = "_b-3";
export var main = "_b-c";
export var modal = "_b-0";
export var neutral = "_b-s";
export var noPadding = "_b-e";
export var none = "_b-t";
export var scrollable = "_b-d";
export var small = "_b-2";
export var success = "_b-p";
export var tight = "_b-l";
export var titleIcon = "_b-a";
export var warn = "_b-o";